import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
import { getAuthToken } from '../../utils/api';

interface Props {
  children: React.ReactNode;
}

const AdminRoute: React.FC<Props> = ({ children }) => {
  const { userProfile, isLoading } = useUser();
  const location = useLocation();

  if (!getAuthToken()) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/sign-in?next=${next}`} replace />;
  }

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '50vh',
          color: '#6b7280',
          fontSize: '0.9rem',
        }}
        aria-label="Loading admin area"
      >
        Loading…
      </div>
    );
  }

  if (!userProfile) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/sign-in?next=${next}`} replace />;
  }

  if (!userProfile.is_admin) {
    return <Navigate to="/404" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
